import React from 'react'
import './../styles/Footer.css'
import { Link } from 'react-router-dom'
import linkedinLogo from '../assets/social/linkedin-ligth-blue-icon.png'
import logo from '../assets/logos/qatech-logo.svg'
import { trackOutboundClick, trackEvent } from '../utils/analytics'

const Footer = () => (
  <footer className="footer">
    <div className="footer-content">
      <div className="footer-left">
        <p>&copy; {new Date().getFullYear()} QA Tech Consultancy. All rights reserved.</p>
        <p>
          <Link to="/privacy-policy">Privacy Policy</Link>
        </p>
      </div>
      <div className="footer-right">
        <h4>Connect With Us</h4>
        <div className="social-media-container">
          <a
            href="https://www.linkedin.com/company/qa-tech-consultancy"
            target="_blank"
            rel="noopener noreferrer"
            className="social-media-logo"
            aria-label="Follow us on LinkedIn"
            onClick={() => trackOutboundClick(
              'https://www.linkedin.com/company/qa-tech-consultancy',
              'LinkedIn',
              'footer_social'
            )}
          >
            <img src={linkedinLogo} alt="LinkedIn" />
          </a>
        </div>
      </div>
    </div>
    
    <div className="footer-company">
      <div className="footer-logo">
        <img src={logo} alt="QA Tech Logo" style={{ height: '40px' }} />
      </div>
      <p className="footer-tagline">Building Confidence Through Quality</p>
      
      <div className="footer-contact">
        <div className="footer-contact-item">
          <span>📧</span>
          <a
            href="mailto:info@qatechltd.com"
            onClick={() => trackEvent('email_click', { email_location: 'footer' })}
          >
            info@qatechltd.com
          </a>
        </div>
        <div className="footer-contact-item">
          <span>🌐</span>
          <span>United Kingdom</span>
        </div>
      </div>
      
      <div className="footer-copyright">
        <p>Designed with modern web technologies • Built for excellence in software quality assurance</p>
      </div>
    </div>
  </footer>
)

export default Footer
